// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"024bf81e","455":"3e9dd730","977":"2cddd368"}[chunkId] + ".chunk.js";
};